<template>
  <v-container grid-list-md class="mt-5">
    <base-v-component
      class="mt-n5"
      icon="mdi-cog-outline"
      heading="DEVOLUCIONES GENERALES"
    />
    <base-material-card
      color="indigo darken-4"
      icon="mdi-keyboard-return"
      inline
      class="elevation-10"
    >
      <template v-slot:after-heading class="text-lg-center">
        <base-v-component heading="" />
      </template>
      <v-layout row wrap justify-end>
        <!-- <v-layout justify-end> -->
        <v-col cols="12" sm="12" md="5" lg="4" xl="3">
          <v-autocomplete
            clearable
            v-model="branchOfficeId"
            :items="BranchOffice"
            persistent-hint
            item-text="name"
            item-value="id"
            color="indigo darken-4"
            dense
            label="Selecciona Una Sucursal"
            return-object
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="2" class="ml-2">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDate"
                append-icon="mdi-calendar-multiselect"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="es"
              color="indigo darken-3"
              :max="finishDate"
              v-model="startDate"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="2" class="ml-2">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="finishDate"
                append-icon="mdi-calendar-multiselect"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="es"
              color="indigo darken-3"
              :min="startDate"
              v-model="finishDate"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!--   </v-layout> -->
      </v-layout>
      <v-flex>
        <v-data-table
          :headers="headers"
          hide-default-footer
          disable-pagination
          dense
          :loading="loading"
          loading-text="Buscando Espere.."
          :items="DataItems"
          class="elevation-8"
          no-data-text="No hay datos disponibles... Seleccione una Sucursal"
        >
          <template v-slot:top>
            <export-button
              :items="DataItems"
              :headers="headers"
              :title="'Reporte de devoluciones generales'"
              @SaveExcel="SaveExcel"
            ></export-button>
          </template>
          <template v-slot:item.date="{ item }">
            {{ FormatDate(item.date) }}</template
          >
          <template v-slot:item.totalAmount="{ item }">
            {{ SetCoin(item.totalAmount) }}
          </template>

          <template v-slot:item.returnId="{ item }"
            >{{ FormatFolio(item.returnId) }}
          </template>

          <template v-slot:item.options="{ item }">
            <v-btn @click="OpenDetails(item)" small icon color="indigo">
              <v-icon> mdi-pencil </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </base-material-card>
    <modal-detalles
      :dialog="Showdetails"
      @Close="Showdetails = false"
    ></modal-detalles>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";
import XLSX from "xlsx";
import { mapMutations, mapState } from "vuex";
moment.locale("es");
export default {
  components: {
    ModalDetalles: () => import("./modals/modal"),
    ExportButton: () => import("../../views/Reportes/Export/ExporTest"),
  },
  watch: {
    branchOfficeId(val) {
      console.log(val);
      this.LoadData();
    },
    startDate(val) {
      this.LoadData();
    },
    finishDate(val) {
      this.LoadData();
    },
  },
  created() {
    const v = this.BranchOffice;
    if (v.legth === 0) {
      this.LoadBranh();
    }
    this.LoadData();
  },
  data: () => ({
    Showdetails: false,
    branchOfficeId: null,
    menu: null,
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    menu2: null,
    finishDate: moment().format("YYYY-MM-DD"),
    loading: false,
    DataItems: [],
    headers: [
      {
        text: "Sucursal",
        value: "branchOffice",
      },
      {
        text: "Fecha",
        value: "date",
      },
      {
        text: "Emleado",
        value: "employee",
        align: "left",
      },
      {
        text: "Artículos",
        value: "quantityOfArticles",
        align: "right",
      },
      {
        text: "Folio devolucion",
        value: "returnId",
        align: "center",
      },
      {
        text: "Monto",
        value: "totalAmount",
        align: "right",
      },
    ],
    bool: false,
  }),
  methods: {
    ...mapMutations({
      SetBranh: "SET_BRANCH",
    }),
    SaveExcel() {
      let val = [];

      val = _.map(this.DataItems, (e) => {
        //this.DataItems;
        delete e.localReturnId;
        delete e.localNoteId;
        return e;
      });

      console.log(val);
      let data = XLSX.utils.json_to_sheet(val, {
        header: [
          `branchOffice`,
          `date`,
          `employee`,
          `quantityOfArticles`,
          `returnId`,
          `totalAmount`,
        ],
      });

      data[`A1`].v = "Sucursal";
      data[`B1`].v = "Fecha";
      data[`C1`].v = "Empelado";
      data[`D1`].v = "No. Artículos";
      data[`E1`].v = "Folio devolución";
      data[`F1`].v = "Monto";

      const workbook = XLSX.utils.book_new();
      const filename = "Devoluciones-Generales";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    FormatFolio(item) {
      /* Los ceros los almacenamos como cadena, no como número */
      var cadenaNumerica = "00000";
      /* Esto concatenará cadenas, convirtiendo "numero" en una */
      var resultado = cadenaNumerica + item;
      /* Nos quedamos con la parte final (con la misma longitud que los 0 iniciales) */
      resultado = resultado.substring(resultado.length - cadenaNumerica.length);
      /* Mostramos el resultado */
      return resultado;
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    SetCoin(price) {
      return "$ " + this.formatNumber(parseFloat(price).toFixed(2));
    },
    FormatDate(item) {
      return moment(item).format("YYYY-MM-DD hh:mm a");
    },
    OpenDetails(item) {
      this.Showdetails = true;
    },
    LoadBranh() {
      let bussinessAccountId = localStorage.getItem("_bussinessAccountId");
      axios
        .get(`/api/BranchOffice/GetByAccount/${bussinessAccountId}`)
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.SetBranh(data);
          // this.$store.commit("SET_BRANCH", data);
        });
    },
    LoadData() {
      let branchId = this.branchOfficeId;

      if (branchId !== null) {
        if (branchId !== undefined) {
          branchId = this.branchOfficeId.id;
        }
      }
      axios
        .post(
          "/api/Return/Get",
          {
            branchOffice: branchId,
            startDate: moment(this.startDate).startOf("day"),
            finishDate: moment(this.finishDate).endOf("day"),
          },
          {
            headers: {
              bussinessId: localStorage.getItem("_bussinessAccountId"),
            },
          }
        )
        .then((result) => {
          const d = result.data;
          this.DataItems = d;
        });
    },
  },
  computed: {
    BranchOffice: {
      get() {
        return this.$store.state.BranchOffice;
      },
      set(val) {
        this.$store.commit("SET_BRANCH", val);
      },
    },
  },
};
</script>
